export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="flex items-center gap-3 mb-3 justify-center">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-information-line text-background-50 text-lg"></i>
            </div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于我们</h2>
          </div>
          <p className="text-foreground-500 text-sm mb-8">了解吃瓜视频在线观看平台</p>

          <div className="text-left bg-background-100 rounded-2xl p-6 md:p-8">
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              吃瓜视频在线观看是一个专注于娱乐八卦内容聚合的在线视频平台。
              我们汇集了51吃瓜、91吃瓜、黑料吃瓜等热门内容源的高清视频资源，
              为吃瓜爱好者提供一站式的在线观看体验。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-4">
              平台每日更新最新吃瓜视频，覆盖娱乐圈、网红圈、综艺圈等各个领域的热点事件。
              我们的编辑团队全天候追踪全网最热话题，确保你不错过任何一个值得关注的瓜。
              所有视频均支持高清流畅播放，即点即看，无需下载任何软件或插件。
            </p>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed">
              我们坚持内容真实、更新及时、体验流畅的原则，致力于打造最受吃瓜群众信赖的
              在线观看平台。无论你是51吃瓜的老粉还是91在线吃瓜的新用户，
              这里都有你想要的内容。黑料吃瓜在线观看，就在吃瓜视频。
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mt-8">
            {[
              { num: '3年+', label: '稳定运营' },
              { num: '50万+', label: '日活用户' },
              { num: '10万+', label: '视频资源' },
              { num: '99.9%', label: '在线可用率' },
            ].map((item, i) => (
              <div key={i} className="p-4 rounded-xl bg-background-100">
                <div className="font-heading text-xl md:text-2xl font-bold text-primary-600">{item.num}</div>
                <div className="text-xs text-foreground-500 mt-1">{item.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}